// eslint-disable-next-line no-restricted-imports
import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import { isEmail, isNotEmpty, optional, validateRecord } from '@gonfalon/legacy-form-validation/validationUtils';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

export type TaxAddressType = ImmutableMap<{
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}> | null;

export type BillingContactType = {
  name: string | null;
  email: string | null;
  company: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  poNumber: string | null;
  taxAddress: TaxAddressType;
};

export class BillingContact extends Record<BillingContactType>({
  name: null,
  email: null,
  company: null,
  address1: null,
  address2: null,
  city: null,
  state: null,
  postalCode: null,
  country: null,
  poNumber: null,
  taxAddress: null,
}) {
  validate() {
    let predicates = [
      isNotEmpty('name'),
      optional(isEmail)('email'),
      isNotEmpty('address1'),
      isNotEmpty('city'),
      isNotEmpty('postalCode'),
      isNotEmpty('country'),
      isNotEmpty('state'),
    ];

    if (this.taxAddress !== null) {
      predicates = predicates.concat(
        isNotEmpty('taxAddress.address1'),
        isNotEmpty('taxAddress.city'),
        isNotEmpty('taxAddress.postalCode'),
        isNotEmpty('taxAddress.country'),
        isNotEmpty('taxAddress.state'),
      );
    }

    return validateRecord(this, ...predicates);
  }

  isValid() {
    return this.validate().isEmpty();
  }
}

export function createBillingContact(props = {}) {
  return props instanceof BillingContact ? props : new BillingContact(fromJS(props));
}
